import React, { useState } from 'react';
import { FaUser, FaCalendar, FaTimes } from 'react-icons/fa';

const AcceptedCandidates = ({ applications, onScheduleTest }) => {
  const [selectedDate, setSelectedDate] = useState('');
  const [schedulingFor, setSchedulingFor] = useState(null);
  
  const acceptedApplications = applications.filter(app => app.status === 'accepted');

  const handleScheduleClick = (application) => {
    setSchedulingFor(application);
  };

  const handleSubmitSchedule = () => {
    if (selectedDate && schedulingFor) {
      onScheduleTest(schedulingFor, selectedDate);
      setSelectedDate('');
      setSchedulingFor(null);
    }
  };

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold text-gray-900 mb-4">Accepted Candidates</h2>
      
      {/* Date Picker Modal */}
      {schedulingFor && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Schedule Test</h3>
              <button 
                onClick={() => setSchedulingFor(null)}
                className="text-gray-500 hover:text-gray-700"
              >
                <FaTimes />
              </button>
            </div>
            <p className="text-sm text-gray-600 mb-4">
              Scheduling test for {schedulingFor.userName}
            </p>
            <input
              type="datetime-local"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              className="w-full p-2 border rounded-lg mb-4"
            />
            <div className="flex justify-end gap-2">
              <button
                onClick={() => setSchedulingFor(null)}
                className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-lg"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmitSchedule}
                disabled={!selectedDate}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
              >
                Schedule
              </button>
            </div>
          </div>
        </div>
      )}

      {acceptedApplications.map(application => (
        <div key={application.id} className="bg-white rounded-lg shadow-sm p-4 border border-gray-100">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center">
                <FaUser className="text-white" />
              </div>
              <div>
                <h3 className="font-medium text-gray-900">{application.userName}</h3>
                <p className="text-sm text-gray-600">{application.position}</p>
              </div>
            </div>
            <div className="text-sm">
              {application.testDate ? (
                <span className="text-green-600 flex items-center gap-1">
                  <FaCalendar />
                  {new Date(application.testDate).toLocaleDateString()}
                </span>
              ) : (
                <button
                  onClick={() => handleScheduleClick(application)}
                  className="px-3 py-1 bg-blue-100 text-blue-700 rounded hover:bg-blue-200 transition-colors"
                >
                  Schedule Test
                </button>
              )}
            </div>
          </div>
        </div>
      ))}
      {acceptedApplications.length === 0 && (
        <p className="text-gray-500 text-center py-4">No accepted candidates yet</p>
      )}
    </div>
  );
};

export default AcceptedCandidates;